import {
  Box,
  Button,
  Checkbox,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import api from "../../../../API";
import { useSelector } from "react-redux";
// import _debounce from 'lodash/debounce';
import { DropType } from "./Task08ListPage";
import VieJsonDialog from "../../../admin/vie/VieJsonDialog";

const initailData: DropType = {
  idx: -1,
  id: "",
  worker: "",
  work_date: "",
  work_yn: "",
  use_check: "",

  prc_worker: "",
  prc_date: "",
  prc_yn: "",

  isp_worker: "",
  isp_date: "",
  isp_yn: "",

  category: "",
  
  translate_need:"",

  passage_en: "",
  question_en: "",
  answer_en: "",
  
  passage_vi: "",
  question_vi: "",
  answer_vi: "",

  passage_ko: "",
  question_ko: "",
  answer_ko: "",
};


const Task08DetailDialog = (props: any) => {

  const [data, setData] = useState<any>(initailData);

  // /////////////////////////////////////////////////////////////////

  const [ttaData, setTtaData] = useState<any[] | null>(null);

  const [dataList, setDataList] = useState<{ idx: number; confirm_data: any }[]>([]);

  const handleUpdate = (idx: number, value: any) => {
    setDataList((prev:any) =>
      prev.map((item:any) =>
        item.idx === idx ? { ...item, confirm_data: value } : item
      )
    );
  };

  const saveTtaData = async (idx: string) => {
    const confirm_data = dataList.find((item:any) => item.idx === idx)!.confirm_data;
    console.log('Saved Data for idx :', confirm_data);

    const formData = new FormData();

    formData.append("email", email);

    formData.append("confirm_data", confirm_data);

    formData.append("idx", idx);

    await api.post("/vie-tta-update", formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})
  };

  // /////////////////////////////////////////////////////////////////

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [check_1, setCheck_1] = useState(false);
  const [check_2, setCheck_2] = useState(false);
  const [check_3, setCheck_3] = useState(false);
  const [check_4, setCheck_4] = useState(false);
  const [check_5, setCheck_5] = useState(false);
  const [check_6, setCheck_6] = useState(false);
  const [check_7, setCheck_7] = useState(false);
  const [check_8, setCheck_8] = useState(false);
  const [check_9, setCheck_9] = useState(false);
  const [check_10, setCheck_10] = useState(false);

  // const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let manager_role = auth.user.roles.some((obj:any) => ['VIE_PRC','VIE_MANAGER'].includes(obj.role));

  let isp_role = auth.user.roles.some((obj:any) => ['VIE_MANAGER'].includes(obj.role));

  const checkList = (check_num:number) => {
    if(check_num === 1){setCheck_1(!check_1)}
    if(check_num === 2){setCheck_2(!check_2)}
    if(check_num === 3){setCheck_3(!check_3)}
    if(check_num === 4){setCheck_4(!check_4)}
    if(check_num === 5){setCheck_5(!check_5)}
    if(check_num === 6){setCheck_6(!check_6)}
    if(check_num === 7){setCheck_7(!check_7)}
    if(check_num === 8){setCheck_8(!check_8)}
    if(check_num === 9){setCheck_9(!check_9)}
    if(check_num === 10){setCheck_10(!check_10)}
  }

  // const getAuths = async () => {
  //   var result = await api.get("/getAuths");
  //   setAuths(result.data.data);
  // };


  const saveDropData = async (translate:string) => {

    const formData = new FormData();

    

    if(data.use_check === "None"){
      alert('체크결과 를 선택하세요.')
      return;
    }

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" && data.category === "None" && data.use_check !== "F"){
      alert('Category 를 선택하세요.')
      return;
    }

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.question_vi === null || data.question_en === null || data.question_ko === null || data.question_vi === "" || data.question_en === "" || data.question_ko === "")
    ){
      alert('question 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.passage_vi === null || data.passage_en === null || data.passage_ko === null || data.passage_vi === "" || data.passage_en === "" || data.passage_ko === "")
    ){
      alert('passage 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.answer_en === "None" || data.answer_en === "" || data.answer_vi === "None" || data.answer_vi === "" || data.answer_ko === "None" || data.answer_ko === "")
    ){
      alert('Answer 을 선택하세요 (EN , VI , KO).')
      return;
    }


    // if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
    //   (data.cot_content_vi === null || data.cot_content_en === null || data.cot_content_ko === null || data.cot_content_vi === "" || data.cot_content_en === "" || data.cot_content_ko === "")
    // ){
    //   alert('Cot_Content (답변에 대한 설명) 를 입력하세요 (EN , VI , KO).')
    //   return;
    // }

    if(manager_role === true && data.prc_yn === 'None'){
      alert('가공결과 를 선택하세요.')
      return;
    }

    if(isp_role === true && data.isp_yn === 'None'){
      alert('검수결과 를 선택하세요.')
      return;
    }

    if(translate === 'need'){
      formData.append("translate_need", 'Y');
    }

    formData.append("email", email);

    formData.append("datas", JSON.stringify(data));

    if(manager_role !== true){
      let check_list = ""
      if(check_1){check_list+="1"}
      if(check_2){check_list+="2"}
      if(check_3){check_list+="3"}
      if(check_4){check_list+="4"}
      if(check_5){check_list+="5"}
      if(check_6){check_list+="6"}
      if(check_7){check_list+="7"}
      if(check_8){check_list+="8"}
      if(check_9){check_list+="9"}
      if(check_10){check_list+="10"}
  
      formData.append("checklist", check_list);
    }

    await api.post("/vie-08-dropUpdate",formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); props.updateAfter(); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const openGuideWindow = () => {
    const imageUrl = `${process.env.PUBLIC_URL}/img/vie-task/Vie-DROP.jpg`;

    window.open(imageUrl, '_blank');
  }

  const getTtaData = useCallback(async (detail:any) => {

    api.get('/vie-tta-dataList',{params:{email:email,task:'08',task_idx:detail.idx}})
    .then((resp:any) => {setTtaData(resp.data.datas); console.log("결과", resp.data.datas)})
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  },[email])

  useEffect(() => {
    // getAuths();
    setData(initailData);
    setData(props.rowDetail);
    setTtaData([])
    getTtaData(props.rowDetail)
  }, [props.rowDetail, getTtaData]);

  useEffect(() => {
    // ttaData가 null이 아닐 때 초기 상태 설정
    if (ttaData) {
      setDataList(ttaData.map((tt) => ({ idx: tt.idx, confirm_data: tt.confirm_data || "" })));
    }
  }, [ttaData]);

  return (
    <Paper sx={{width:"100%", overflow: "auto", padding:"20px"}}>
      {data ? 
      <>
      <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>데이터 확인</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box>
        <Box sx={{position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >

          {/* <Box display="flex" justifyContent="center"> */}
          <Box display="flex">

            <Box display="flex" sx={{marginLeft: "50px"}}>
              <Box sx={{width:"100%"}}>
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>idx</Box>
                  <Box sx={{fontSize:"14px", width:"130px"}}>{data.idx}</Box>
                </Box>
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>id</Box>
                  <Box sx={{fontSize:"14px", width:"130px"}}>{data.id}</Box>
                </Box>
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>작업워커</Box>
                  <Box sx={{fontSize:"14px", width:"190px"}}>{data.worker}</Box>

                  <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>작업상태</Box>
                  <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                      backgroundColor: (data.work_yn === "Y" ? "#27cc2f" : "#bbb"), color:"#fff"
                  }}>
                    {(data.work_yn === "Y" ? "작업완료" : "미작업")}
                  </Box>

                  <Box sx={{fontSize:"14px",fontWeight:700, width:"120px", marginLeft:"32px"}}>번역검토필요</Box>
                  <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                      backgroundColor: (data.translate_need === "Y" ? "#9c27b0" : (data.translate_need === "None" ? "#bbb" : "#27cc2f")), color:"#fff"
                  }}>
                    {(data.translate_need === "Y" ? "검토필요" : (data.translate_need === "None" ? "미작업" : "검토완료"))}
                  </Box>
                </Box>
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>업데이트시간</Box>
                  <Box sx={{fontSize:"14px", width:"190px"}}>{data.work_date}</Box>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>체크결과</Box>
                  <Select id="use_check" value={data.use_check} onChange={(e) => {setData({ ...data, use_check: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                    <MenuItem dense value={"T"}>T - 사용가능</MenuItem>
                    <MenuItem dense value={"C"}>C - 내용수정</MenuItem>
                    <MenuItem dense value={"F"}>F - 사용불가</MenuItem>
                  </Select>
                </Box>
                {manager_role ? 
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>가공시간</Box>
                  <Box sx={{fontSize:"14px", width:"190px"}}>{data.prc_date}</Box>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>가공결과</Box>
                  <Select id="prc_yn" value={data.prc_yn} onChange={(e) => {setData({ ...data, prc_yn: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                    <MenuItem dense value={"Y"}>가공완료</MenuItem>
                    <MenuItem dense value={"N"}>가공부적합</MenuItem>
                    <MenuItem dense value={"None"}>-</MenuItem>
                  </Select>
                </Box>
                :""}
                {isp_role && data.prc_yn === 'Y' ? 
                  <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>검수시간</Box>
                    <Box sx={{fontSize:"14px", width:"190px"}}>{data.isp_date}</Box>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>검수결과</Box>
                    <Select id="isp_yn" value={data.isp_yn} onChange={(e) => {setData({ ...data, isp_yn: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                      <MenuItem dense value={"Y"}>검수완료</MenuItem>
                      <MenuItem dense value={"N"}>검수부적합</MenuItem>
                      <MenuItem dense value={"None"}>-</MenuItem>
                    </Select>
                  </Box>
                :<></>}
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"96px"}}>Category</Box>
                  <Select id="category" value={data.category} onChange={(e) => {setData({ ...data, category: e.target.value });}} sx={{color:"green",width:"250px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                    <MenuItem dense value={"사회/정치/산업"}>사회/정치/산업</MenuItem>
                    <MenuItem dense value={"건강/의학"}>건강/의학</MenuItem>
                    <MenuItem dense value={"날씨/자연/동식물"}>날씨/자연/동식물</MenuItem>
                    <MenuItem dense value={"음식/일상생활"}>음식/일상생활</MenuItem>
                    <MenuItem dense value={"IT/과학"}>IT/과학</MenuItem>
                    <MenuItem dense value={"역사/문화/예술/공예/의상"}>역사/문화/예술/공예/의상</MenuItem>
                    <MenuItem dense value={"일반상식/기타"}>일반상식/기타</MenuItem>
                  </Select>
                  <Button variant="contained" size="small" color="secondary" sx={{fontWeight:700, margin:"8px 16px 8px 250px"}} onClick={() => openGuideWindow()}>
                    OPEN GUIDE
                  </Button>
                  {manager_role ? 
                  <Button variant="contained" size="small" sx={{fontWeight:700, margin:"8px 16px 8px 200px", backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                    OPEN JSON
                  </Button>
                  :""}
                  {openJsonDialog ? <VieJsonDialog task={"08"} idx={data.idx} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
                </Box>
              </Box>
            </Box>
        
          {/* </form> */}
          </Box>

          <Box display="flex" justifyContent="center" sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
                {/* <Box sx={{fontSize:"14px", fontWeight:700,width:"90%"}}>기존 스크립트(0 줄)</Box>
                <Box sx={{fontSize:"14px", fontWeight:700,width:"100%"}}>수집 SRT(0 줄)</Box> */}
                <Box sx={{fontSize:"36px", paddingTop:"8px", color:"#60ad50", fontWeight:700}}><b style={{color:"#000"}}> </b></Box>
                
              </Box>
              

            </Box>

            {/* TTA */}
              <Box>
                {ttaData !== null && dataList && ttaData.map((tt:any,index:number) => 
                  <Box key={tt.idx+index} sx={{border:"3px solid #498ad5"}}>
                    <Box display="flex" justifyContent="center" sx={{alignItems:"center"}}>
                      <Box sx={{width:"200px",fontWeight:600,fontSize:"20px", marginRight:"6px", textAlign:"center"}}>{tt.desc}</Box>
                      <textarea defaultValue={tt.err_data} style={{width:"600px", height:"20px", fontSize:"16px", padding:"2px"}} />
                    </Box>
                    <Box display="flex" justifyContent="center" sx={{alignItems:"center"}}>
                      <Box sx={{width:"200px",fontWeight:600,fontSize:"20px", marginRight:"6px", textAlign:"center"}}>소명사유</Box>
                      {dataList.find((item:any) => item.idx === tt.idx) !== undefined &&
                        <textarea value={dataList.find((item:any) => item.idx === tt.idx)!.confirm_data || ""}
                        onChange={(e) => handleUpdate(tt.idx, e.target.value)}
                          style={{
                            width: "600px",
                            height: "20px",
                            fontSize: "16px",
                            padding: "2px",
                          }}
                        />
                      }
                      <Button
                        variant="contained"
                        sx={{ fontWeight: 700, margin: "8px 16px" }}
                        onClick={() => saveTtaData(tt.idx)}
                      >
                        저장
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
    
            {/* TTA */}

            <Box sx={{height:"100%", overflow:"auto", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
          <Box display="flex" justifyContent="center" >

          <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
            <Box sx={{width:"450px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                      <Box><textarea value={data.answer_en || ""} onChange={(e) => {setData({ ...data, answer_en: e.target.value });}} style={{width:"430px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Passage</Box>
                      <Box><textarea value={data.passage_en || ""} onChange={(e) => {setData({ ...data, passage_en: e.target.value });}} style={{width:"430px",minHeight:"150px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea value={data.question_en || ""} onChange={(e) => {setData({ ...data, question_en: e.target.value });}} style={{width:"430px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"450px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>VI</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                      <Box><textarea spellCheck="false" value={data.answer_vi || ""} onChange={(e) => {setData({ ...data, answer_vi: e.target.value });}} style={{width:"430px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Passage</Box>
                      <Box><textarea spellCheck="false" value={data.passage_vi || ""} onChange={(e) => {setData({ ...data, passage_vi: e.target.value });}} style={{width:"430px",minHeight:"150px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea spellCheck="false" value={data.question_vi || ""} onChange={(e) => {setData({ ...data, question_vi: e.target.value });}} style={{width:"430px",minHeight:"60px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              
            </Paper>

            <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"450px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                      <Box><textarea value={data.answer_ko || ""} onChange={(e) => {setData({ ...data, answer_ko: e.target.value });}} style={{width:"430px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Passage</Box>
                      <Box><textarea value={data.passage_ko || ""} onChange={(e) => {setData({ ...data, passage_ko: e.target.value });}} style={{width:"430px",minHeight:"150px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea value={data.question_ko || ""} onChange={(e) => {setData({ ...data, question_ko: e.target.value });}} style={{width:"430px",minHeight:"60px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            
          </Box>
          {(manager_role !== true && props.createVie !== 'true') ? 
          <Box sx={{border:"2px solid #4539ca", backgroundColor:"#fff", width:"600px", margin:"12px 84px 12px auto"}}>
            <Box sx={{fontSize:"14px",fontWeight:700, margin:"4px", width:"102px"}}>체크리스트</Box>
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(1)} checked={check_1}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>1. 원시데이터와 환경정보(메타정보)의 내용이 일치하는가?</Box></Box>     
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(2)} checked={check_2}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>2. 민감한 이슈(정치), 이메일 연락처, 개인고유식별번호 등의 포함 여부 확인 하였는가?</Box></Box>     
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(3)} checked={check_3}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>3. 무분별한 비난 또는 혐오적인 내용의 포함 여부 확인하였는가?</Box></Box>
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(4)} checked={check_4}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>4. 선정적인 내용 또는 상업적 목적의 내용은 제외되었는가?</Box></Box>
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(5)} checked={check_5}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>5. 오타나 문법 오류 등은 수정되었는가?</Box></Box>     
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(6)} checked={check_6}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>6. 저작권 침해 가능성 여부는 확인하였는가?</Box></Box>      
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(7)} checked={check_7}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>7. 텍스트 내용에 대한 주제분류는 적합하게 되었는가?</Box></Box> 
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(8)} checked={check_8}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>8. 불필요한 기호나 띄어쓰기, 이모티콘 등은 제거되었는가?</Box></Box> 
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(9)} checked={check_9}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>9. 번역된 부분에 해당언어로 번역이 잘 되었는가?</Box></Box> 
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(10)} checked={check_10}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>10. 베트남 문화와 규범에 올바른 정보인가?</Box></Box> 
          </Box>
          :<></>}
        </Box>

      </Box>
      <Box display="flex" justifyContent="right" sx={{margin:"20px"}}>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            saveDropData('need');
          }}
        >
          SAVE (번역검토필요)
        </Button>
        <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            saveDropData('ok');
          }}
        >
          {manager_role ? "SAVE(검수)" : "SAVE"}
        </Button>
      </Box>
      </> : "데이터가 없습니다."}
      
    </Paper>
  );
};

export default Task08DetailDialog;
